import moment from 'moment'
import { useEffect, useState } from 'react'
import subsidiariesApi from 'services/api/subsidiaries'

import styles from './HotelTags.module.scss'

export const HotelTag = ({ addedOn, addedBy, name }) => (
  <div
    className={styles.tag}
    title={`Added by ${addedBy} on ${moment(addedOn).format('MMM DD, YYYY')}`}
    data-tip={`Added by ${addedBy} on ${moment(addedOn).format('MMM DD, YYYY')}`}
  >
    {name}
  </div>
)

const HotelTags = () => {
  const [tags, setTags] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState()

  useEffect(() => {
    subsidiariesApi.hotelTags
      .get()
      .then(tags => {
        setIsLoading(false)
        setTags(tags)
      })
      .catch(() => {
        setIsLoading(false)
        setIsErred(true)
      })
  }, [])

  if (isLoading) return null

  if (isErred) return <div className={styles.noTags}>Error loading tags</div>

  return (
    <div className={styles.tagsHolder}>
      {tags?.length === 0 && <div className={styles.noTags}>No tags</div>}
      {tags?.map(tag => (
        <HotelTag key={tag.id} {...tag} />
      ))}
    </div>
  )
}

export default HotelTags
